import React from "react";
import Header from "components/Header/Header";
import TextSkeleton from "components/Skeletons/TextSkeleton/TextSkeleton";
import PropTypes from "prop-types";
import useCart from "hooks/useCart";
import { Link } from "react-router-dom";
import { CartIcon, Logo } from "constants/icons";
import { fabpiks } from "../../../constants/images";
import { APP_ROUTES } from "constants/routes";
import "containers/UserDetails/UserDetailsHeader/UserDetailsHeader.css";

function UserDetailsHeader({ vmName }) {
  const { cartTotalQuantities } = useCart();
  return (
    <Header className="homepage__header" isUserDetailsPage={true}>
      {/* <Logo style={{ height: "30px" }} /> */}
      {/* <img src={fabpiks} className="fabpiks" /> */}
      <span className="fabpiks">GET YOUR SAMPLE</span>
    </Header>
  );
}

UserDetailsHeader.propTypes = {
  vmName: PropTypes.string,
};

export default UserDetailsHeader;
